

export const Staking_Data=[
    {
        APY:"6%",
        Days:"30",

    },
    {
        APY:"13%",
        Days:"60",

    } ,{
        APY:"33%",
        Days:"90",

    },
    {
        APY:"50%",
        Days:"180",

    }
]